import React, { useEffect } from 'react';
import { compose, path } from 'js/utils/ramda.util';
import { Loader } from 'js/components/common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { SPORTSBOOK_REDUCER } from 'js/store/constants';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { useComponentMethods, useComponentTranslations } from 'js/hooks/component';

import * as hooks from './hooks';
import * as constants from './constants';
import * as actions from './store/actions';
import { MetaTags } from './components/MetaTags';

import style from './SportsbookApp.scss';

export const SportsbookAppBare = () => {
    const dispatch = useDispatch();
    const translate = useComponentTranslations();
    const { showComponentError } = useComponentMethods();
    const isAppInitError = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitError']));
    const isIntegrationScriptError = useSelector(path([SPORTSBOOK_REDUCER, 'isIntegrationScriptError']));

    useEffect(() => {
        if (isIntegrationScriptError || isAppInitError) {
            showComponentError(translate('error.unavailable'));
        }
    }, [isAppInitError, isIntegrationScriptError, showComponentError, translate]);

    useEffect(() => {
        dispatch(actions.startIntegration());
    }, [dispatch]);

    hooks.useMountSportsbook();
    hooks.useUnmountSportsbook();
    hooks.useNavigateSportsbook();

    return (
        <>
            <MetaTags />
            <div id={constants.CONTAINER_ID}>
                <div className={style.loadingContainer}>
                    <Loader />
                </div>
            </div>
            <div id="sportsbook-modals" className={style.modals}>
                <div id={constants.SPORTS_OVERLAYS_ID} />
            </div>
        </>
    );
};

export const SportsbookApp = compose(
    withComponent({
        tkPrefix: 'playtech.mobile.system.sportsbook.'
    })
)(SportsbookAppBare);

componentService.registerWebContentComponents({ SportsbookApp });
componentService.registerPageComponents({ [constants.SPORTSBOOK_APP]: SportsbookApp });
